import React, { Suspense }  from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './LanguageContext';
import HomePage from './pages/HomePage';
import Articles from './pages/Articles';
import Experience from './pages/Experience';
import ArticleRenderer from './pages/ArticleRenderer';
import ChartLab from './pages/ChartLab';
import NotFound from './pages/NotFound';
import Navbar from './components/NavBar';
import Footer from './components/Footer';
import ScrollToTop from './functions/ScrollToTop';
import { HelmetProvider } from 'react-helmet-async';

// Dev-only text editing (see src/setupProxy.js and src/dev/). The
// NODE_ENV check is a build-time constant, so production builds drop this
// import entirely.
const EditOverlay = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./dev/EditOverlay'))
  : null;

function AppContent() {
  // const navigate = useNavigate();

  // useEffect(() => {
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const article = urlParams.get('article');
  //   if (article) {
  //     navigate(`/article/${article}`, { replace: true });
  //   }
  // }, [navigate]);

  return (
    <>
      <Navbar />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/article/:id" element={<ArticleRenderer />} />
        <Route path="/experience" element={<Experience />} />
        {process.env.NODE_ENV !== 'production' && <Route path="/chart-lab" element={<ChartLab />} />}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
      {EditOverlay && <Suspense fallback={null}><EditOverlay /></Suspense>}
    </>
  );
}

function App() {
  return (
          <HelmetProvider>

    <LanguageProvider>
        <Router>
          <AppContent />
        </Router>
    </LanguageProvider>
          </HelmetProvider>

  );
}

export default App;